import { HttpClient } from '@angular/common/http';
import { DestroyRef, inject } from "@angular/core";
import { ModelFactoryProvider } from '@core/shared/model';
import { ClientCacheService } from '../../client-cache';
import { CrudServiceFactory } from '../crud-service';
import { SimpleItemService } from './simple.item-service';
import { PagedItemService } from './paged.item-service';
import { LazyLoadItemService } from './lazy-load.item-service';
import * as i0 from "@angular/core";
;
export function itemServiceFactoryDepsToCtorArgs(d) {
  return [d.http, d.modelFactoryProvider, d.clientCache, d.crudFactory, d.destroyRef];
}
export function itemServiceFactoryFacade(deps) {
  return {
    createCustomItemService(ClassCtor, setupData) {
      const inst = new ClassCtor(...itemServiceFactoryDepsToCtorArgs(deps));
      inst.setupCrudService(setupData);
      return inst;
    },
    createSimpleItemService(setupData) {
      const inst = new SimpleItemService(...itemServiceFactoryDepsToCtorArgs(deps));
      inst.setupCrudService(setupData);
      return inst;
    },
    createPagedItemService(setupData) {
      const inst = new PagedItemService(...itemServiceFactoryDepsToCtorArgs(deps));
      inst.setupCrudService(setupData);
      return inst;
    },
    createLazyLoadItemService(setupData) {
      const inst = new LazyLoadItemService(...itemServiceFactoryDepsToCtorArgs(deps));
      inst.setupCrudService(setupData);
      return inst;
    },
    get crud() {
      return deps.crudFactory;
    }
  };
}
export let ItemServiceFactory = /*#__PURE__*/(() => {
  class ItemServiceFactory {
    constructor() {
      this.deps = {
        http: inject(HttpClient),
        modelFactoryProvider: inject(ModelFactoryProvider),
        clientCache: inject(ClientCacheService),
        crudFactory: inject(CrudServiceFactory),
        destroyRef: inject(DestroyRef)
      };
    }
    useDestroyRef(destroyRef) {
      return itemServiceFactoryFacade({
        ...this.deps,
        destroyRef
      });
    }
    get crud() {
      return this.deps.crudFactory;
    }
    static {
      this.ɵfac = function ItemServiceFactory_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ItemServiceFactory)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: ItemServiceFactory,
        factory: ItemServiceFactory.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ItemServiceFactory;
})();